import { makeStyles } from '@material-ui/core'

import { lang } from '../../../localization'

const useStyles = makeStyles((theme) => ({
  ratePlanRow: {
    display: 'grid',
    gridTemplateColumns: '4.121fr 1.299fr repeat(14,1fr)',
    height: 40,
    alignItems: 'center',
    backgroundColor: theme.palette.grey[300]
  },
  ratePlanRowForMonth: {
    gridTemplateColumns: '9.122fr 2.878fr repeat(31,1fr)'
  },
  rowNameContainer: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '3%'
  },
  rowName: {
    marginLeft: 48,
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    fontSize: 15
  },
  ratePlanArrowRight: {
    marginRight: 6,
    fontSize: 14,
    transition: `transform 0.2s`,
    transform: `rotate(${lang === 'fa' ? '180deg' : '0deg'})`
  },
  ratePlanArrowDown: {
    transform: `rotate(${lang === 'fa' ? '-90deg' : '90deg'})`
  },
  numberOfChannels: {
    color: theme.palette.primary.main,
    cursor: 'pointer'
  },
  channelLoading: {
    width: 14,
    marginRight: 6,
    marginLeft: 4,
    marginTop: 4
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  emptyBox: {
    height: '100%',
    borderLeft: `1px solid ${theme.palette.grey[200]}`
  },
  weekendDayContainer: {
    backgroundColor:
      theme.palette.type === 'dark' ? `rgba(120, 132, 255,0.25)` : '#fff2f2',
    borderLeft: `1px solid ${theme.palette.grey[300]}`,
    borderTop: `1px solid ${theme.palette.grey[300]}`
  }
}))

export default useStyles
